import React from "react";
import Checkbox from "../Checkbox";
import SupportingText from "../SupportingText";

export default function PriceToggleRow({ isChecked, attribute }) {
  return (
    <React.Fragment>
      <div className="py-2 pointer-events-none">
        <Checkbox size="6" checked={isChecked} readOnly={true} />
      </div>
      <SupportingText textSize="base" textColor="black" textAlign="center">
        {attribute}
      </SupportingText>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/PriceToggleRow/PriceToggleRow.js